/**
 * exatrek REST API
 * Some custom description of API.
 *
 * The version of the OpenAPI document: v3
 * Contact: dev@exatrek.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { WorkstateConditionDto } from './workstateConditionDto';
import { CanValueMappingDto } from './canValueMappingDto';

export interface ImplementUpdateCustomSettingsDto {
  canValueMappings?: { [key: string]: CanValueMappingDto };
  id?: number;
  overrideConditionsWithISOBUS?: boolean;
  workstateConditions?: Array<WorkstateConditionDto>;
}
